import { Badge, Tooltip } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Contract } from "../../../DeliveryOverview.types";

export function getIsTemplateColumn(): MRT_ColumnDef<Contract> {
  return {
    accessorKey: "is_template",
    header: "",
    enableSorting: false,
    size: 100,
    enableColumnFilter: false,
    Cell: ({ row }) =>
      row.original.is_template && (
        <Tooltip
          label="Dieser Vertrag kann als Vorlage für neue Verträge verwendet werden."
          multiline
          w={400}
        >
          <Badge color="info" size="sm">
            Referenz
          </Badge>
        </Tooltip>
      )
  };
}
